// extracted by mini-css-extract-plugin
export var columnList = "_gw-0";